import { ReactElement } from 'react';
import BreakpointProvider from '~/components/util/BreakpointProvider';
import Footer, { FooterProps } from '~/components/footer/Footer';

export default (props: FooterProps): ReactElement => (
  <BreakpointProvider>
    <Footer {...props} />
  </BreakpointProvider>
);
